// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__5ZYq_","animate":"Badge_animate__BpSH3","animation-eyp2zy":"Badge_animation-eyp2zy__NtcMF","small":"Badge_small__IvX6O"};